import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAuthorDescription, getAuthorLabel, getMortgagePartnerLink, getAuthorName } from './helpers';
import { ActionButtonContainer } from './parts';
import { PromoDetailsModal } from '../../components/PromoDetailsModal';
import { hasContactsSelector } from '../../selectors/newbuilding';
import { closePromo } from '../../slices';
import { promoSelector } from '../../selectors/promo';
import { useApplicationContext } from '../../utils/applicationContext';

export const PromoDetailsContainer: React.FC = () => {
  const promo = useSelector(promoSelector);
  const hasContacts = useSelector(hasContactsSelector);
  const dispatch = useDispatch();

  const { config } = useApplicationContext();
  const mortgagePartnerLink = getMortgagePartnerLink(promo, config);

  /* istanbul ignore next */
  const handleClose = React.useCallback(() => {
    dispatch(closePromo());
  }, [dispatch]);

  if (!promo) {
    return null;
  }

  return (
    <PromoDetailsModal
      authorDescription={getAuthorDescription(promo, hasContacts)}
      authorLogoUrl={promo.authorLogoUrl}
      authorLabel={getAuthorLabel(promo)}
      authorName={getAuthorName(promo)}
      contactsButton={
        <ActionButtonContainer promo={promo} hasContacts={hasContacts} authorRealtyUserId={promo.authorRealtyUserId} />
      }
      bank={promo.bank}
      banks={promo.banks}
      description={promo.description}
      features={promo.features}
      mortgagePartnerLink={mortgagePartnerLink}
      subtitle={promo.end}
      title={promo.name}
      onClose={handleClose}
      open
    />
  );
};
